
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.824 15.344c-.357-.194-.824.052-.824.458V17c0 2.272 3.95 4 9 4s9-1.728 9-4v-1.198c0-.406-.467-.652-.824-.458-.185.1-.375.195-.571.285C17.778 16.47 15.224 17 12 17s-5.778-.53-7.605-1.37a9.663 9.663 0 01-.57-.286zM21 6.086C21 7.79 16.97 9 12 9S3 7.79 3 6.086C3 4.382 7.03 3 12 3s9 1.382 9 3.086zM12 11c2.62 0 5.087-.316 6.968-.911.424-.135.844-.291 1.244-.475.355-.163.788.085.788.476v1.41c0 1.5-2.95 3.5-9 3.5s-9-2-9-3.5v-1.41c0-.391.433-.639.788-.476.4.184.82.34 1.244.475C6.913 10.684 9.38 11 12 11z"}})])
          )
        }
      }
    